<ProgressBar :progress="progress" :fadeout="fadeout" :showPercent="showPercent"/>

